export default __webpack_public_path__ + "resources/icons/n200-b5e8.webp";